import { render, staticRenderFns } from "./HomeGallerys.vue?vue&type=template&id=72d88735&scoped=true&"
import script from "./HomeGallerys.vue?vue&type=script&lang=js&"
export * from "./HomeGallerys.vue?vue&type=script&lang=js&"
import style0 from "./HomeGallerys.vue?vue&type=style&index=0&id=72d88735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d88735",
  null
  
)

export default component.exports